import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  HotelStarRatingWithoutNotAvailable,
} from "@b2bportal/core-types";
import {
  toStarRating,
  toStarRatingForAvailableRating,
} from "@b2bportal/core-utilities";
import type { HotelStarRating } from "@b2bportal/lodging-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CheckboxGroup, Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterRating.module.scss";

export type FilterRatingProps = {
  selectedValues: HotelStarRating[];
  onChange: (values: HotelStarRating[]) => void;
  className?: string;
};

const ratings = Object.values(HotelStarRatingWithoutNotAvailable).sort(
  (a, b) => {
    return (
      toStarRatingForAvailableRating(b) - toStarRatingForAvailableRating(a)
    );
  }
);

export const FilterRating = ({
  selectedValues,
  onChange,
  className,
}: FilterRatingProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.FilterRating,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, CoreHotelsComponent.FilterRating);
  const { t } = useI18nContext();

  const renderStars = (starRating: number) =>
    Array(starRating)
      .fill(0)
      .map((_, index) => (
        <Icon iconName={IconNameEnum.starFilled} className={cn("star-icon")} />
      ));

  const getRatingLabel = (rating: HotelStarRating) => {
    const starRatingValue = toStarRating(rating);
    return (
      <div className={cn("label")}>
        {t("core-hotels.availabilityPage.results.hotelCard.rating.star", {
          count: starRatingValue,
        })}{" "}
        {starRatingValue != null ? renderStars(starRatingValue) : <></>}
      </div>
    );
  };

  const options = ratings.map((rating) => ({
    label: getRatingLabel(rating),
    value: rating,
  }));

  return (
    <div className={clsx(block, className)}>
      <CheckboxGroup
        options={options}
        checkedOptions={selectedValues}
        onOptionsChange={onChange}
      />
    </div>
  );
};
